<template>

  <div :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners"
       style="width: 373px;background-color: #F4F8FF;">
    <div class="w-full flex-column fs-16 bold" style="height: 44px;"
         :style="{color:iteminfo.config.titleColor,backgroundColor:iteminfo.config.bgColor}">
      {{ iteminfo.config.title }}
    </div>
    <div
      style="width:100%;height:210px;position: relative">
      <img src="../../../assets/menu/bg-mine.png" style="width: 100%">
      <img src="../../../assets/common/icon_portrait_default.png"
           style="position: absolute;top: 20px;left: calc(50% - 30px);width: 60px"/>
      <div class="w-full text-center color-white" style="position: absolute;top: 90px;">请点击登录</div>
    </div>

    <div class="w-full p-h-20"
         style="margin-top: -80px;position: relative;">
      <div style="width: 100%;display: flex;flex-direction: column"
           v-if="iteminfo.config.part1Show===1"
           class="bg-white  b-radius-5">
        <div style="height: 40px;padding-left: 10px;padding-right: 10px" class="flex a-center">
          {{iteminfo.config.part1Title}}
          <div class="flex-1 flex j-end">
            <Icon type="ios-arrow-forward"/>
          </div>
        </div>
        <div class="h-1 m-h-10" style="background-color: #ededed"/>
        <div class="w-full flex flex-1 a-center p-10">

          <div class="flex-column" style="width: 20%;height: 100%;">
            <img src="../../../assets/menu/mine-ic-1.png" alt="">
            <div class="fs-10 m-t-10">待支付</div>
          </div>
          <div class="flex-column" style="width: 20%;height: 100%;">
            <img src="../../../assets/menu/mine-ic-2.png" alt="">
            <div class="fs-10 m-t-10">待发货</div>
          </div>
          <div class="flex-column" style="width: 20%;height: 100%;">
            <img src="../../../assets/menu/mine-ic-3.png" alt="">
            <div class="fs-10 m-t-10">待收货</div>
          </div>
          <div class="flex-column" style="width: 20%;height: 100%;">
            <img src="../../../assets/menu/mine-ic-4.png" alt="">
            <div class="fs-10 m-t-10">已完成</div>
          </div>
          <div class="flex-column" style="width: 20%;height: 100%;">
            <img src="../../../assets/menu/mine-ic-5.png" alt="">
            <div class="fs-10 m-t-10">退款/售后</div>
          </div>

        </div>
      </div>

      <div style="width: 100%;display: flex;flex-direction: column"
           v-if="iteminfo.config.part2Show===1"
           class="bg-white  b-radius-5 m-t-20">
        <div style="height: 40px;padding-left: 10px;padding-right: 10px" class="flex a-center">
          最新消息
          <div class="flex-1 flex j-end">
            <Icon type="ios-arrow-forward"/>
          </div>
        </div>
        <div class="h-1 m-h-10" style="background-color: #ededed"/>
        <div style="height: 40px;padding-left: 10px;padding-right: 10px" class="flex a-center">
          我的订阅
          <div class="flex-1 flex j-end">
            <Icon type="ios-arrow-forward"/>
          </div>
        </div>
        <div class="h-1 m-h-10" style="background-color: #ededed"/>
        <div style="height: 40px;padding-left: 10px;padding-right: 10px" class="flex a-center">
          我的表单
          <div class="flex-1 flex j-end">
            <Icon type="ios-arrow-forward"/>
          </div>
        </div>
      </div>

      <div style="width: 100%;display: flex;flex-direction: column"
           v-if="iteminfo.config.part2Show===1"
           class="bg-white  b-radius-5 m-t-20">
        <div style="height: 40px;padding-left: 10px;padding-right: 10px" class="flex a-center">
          意见反馈
          <div class="flex-1 flex j-end">
            <Icon type="ios-arrow-forward"/>
          </div>
        </div>
        <div class="h-1 m-h-10" style="background-color: #ededed"/>
        <div style="height: 40px;padding-left: 10px;padding-right: 10px" class="flex a-center">
          在线客服
          <div class="flex-1 flex j-end">
            <Icon type="ios-arrow-forward"/>
          </div>
        </div>
        <div class="h-1 m-h-10" style="background-color: #ededed"/>
        <div style="height: 40px;padding-left: 10px;padding-right: 10px" class="flex a-center">
          关于我们
          <div class="flex-1 flex j-end">
            <Icon type="ios-arrow-forward"/>
          </div>
        </div>
      </div>

      <div style="display: flex;flex-direction: column"
           v-if="iteminfo.config.part3Show===1"
           class="bg-white flex-column  b-radius-5 m-t-20 h-40">
        退出登录
      </div>

    </div>


  </div>
</template>

<script>
import BaseDisplayWidget from '../base/BaseDisplayWidget'
import RatioDiv from '../../common/RatioDiv'

export default {
  name: 'MineDisplayWidget',
  components: {
    BaseDisplayWidget,
    RatioDiv,
  },
  props: {
    iteminfo: Object
  },

  data () {
    return {}
  },
  computed: {
    getshowDataList () {
      return this.iteminfo.dataList
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
